import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { base64ToFile, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BoxxImageModel } from '../../models/BoxxImage.model';
import { ImageDimensionsProps } from 'src/services/ImageUtils.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-images-fixer',
  templateUrl: './invalid-images-fixer.component.html',
  styleUrls: ['./invalid-images-fixer.component.scss'],
})
export class BoxxImageFixerComponent implements OnInit {
  @Input() boxxImages: any[] = [];
  @Input() isUrl: boolean;
  @Input() constraints: ImageDimensionsProps;

  croppedImages: BoxxImageModel[] = [];

  totalInvalidImages = 0;

  isCordovaOrCapacitor = false;

  showCropper = false;
  imageChangedEvent: any = '';
  base64String = '';
  transform: ImageTransform = {};

  destroyed$ = new Subject<boolean>();
  translations: any;

  constructor(
    private modalCtrl: ModalController,
    private boxxUtils: BoxxUtilsService,
    private cdr: ChangeDetectorRef,
    translate: TranslateService,
    platform: Platform
  ) {
    platform.ready().then(() => {
      this.isCordovaOrCapacitor = platform.is('cordova') || platform.is('capacitor');
    });

    translate
      .get(['ACTIONS', 'IMAGES_MODULE'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    console.log('boxxImages: ', this.boxxImages);
    this.setTotalInvalidImages();
  }

  removeImage(idx: number) {
    this.croppedImages.splice(idx, 1);
    this.boxxImages.splice(idx, 1);
    this.setTotalInvalidImages();
  }

  async cropImage(index: number) {
    this.boxxImages[index] = this.croppedImages[index];
    this.setTotalInvalidImages();
  }

  async imageCropped(index: number, _bytes: any, event: ImageCroppedEvent) {
    const _newBaseImage = await this.convertBlobToBase64(event.blob) as string;
    const boxximage = new BoxxImageModel({
      bytes: _bytes,//base64ToFile(event.base64).size,
      dimensions: { width: event.width, height: event.height },
      content: _newBaseImage,
      path: null,
    }).validate({
      maxBytes: this.boxxImages[index].validations.bytes.maxBytes,
      maxHeight: this.boxxImages[index].validations.height.maxHeight,
      maxWidth: this.boxxImages[index].validations.width.maxWidth,
    });

    this.croppedImages[index] = boxximage;
    this.setTotalInvalidImages();
    this.cdr.detectChanges();
  }

  convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  loadImageFailed() {
    console.error('Load failed');
  }

  close() {
    this.boxxUtils.showAlert({
      header: this.translations.IMAGES_MODULE.CANCEL_ALERT.header,
      message: this.translations.IMAGES_MODULE.CANCEL_ALERT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.confirm,
          handler: () => {
            this.modalCtrl.dismiss({
              images: this.boxxImages.filter(img => img.validations.valid),
            });
          },
        },
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
      ],
    });
  }

  ok() {
    this.modalCtrl.dismiss({
      images: this.boxxImages.filter(image => image.validations.valid),
    });
  }

  private setTotalInvalidImages() {
    this.totalInvalidImages = this.boxxImages.filter(val => !val.validations.valid).length;
  }
}
